/* =========================================================
   OVERTOP / Urban-Haul — Cart Sync + Empty Auto-Close
   ---------------------------------------------------------
   Horizon's header cart bubble updates only from the itemCount
   carried on cart:update events. When the last line is removed
   the cart section re-renders to its empty branch (no item-count
   node) and the bubble can keep a stale count.

   This re-syncs the header cart bubble from the authoritative
   /cart.js after every cart change, and — when the cart becomes
   empty — smoothly auto-closes the cart drawer. Source of truth
   is always the live cart, so the icon can never go stale.
   ========================================================= */

(function () {
  'use strict';

  window.__OT_CART_SYNC_VERSION = '1.1.0';

  var origFetch = (window.fetch ? window.fetch.bind(window) : null);

  function root() {
    try {
      return String((window.Shopify && Shopify.routes && Shopify.routes.root) || '/').replace(/\/$/, '');
    } catch (e) { return ''; }
  }

  /* ---------- header cart bubble ---------- */
  function bubbleEls() {
    return {
      icon: document.querySelector('cart-icon, .header-actions__cart-icon'),
      bubble: document.querySelector('[ref="cartBubble"], .cart-bubble'),
      count: document.querySelector('[ref="cartBubbleCount"], .cart-bubble__text-count')
    };
  }

  function setBubble(count) {
    count = Number(count) || 0;
    var els = bubbleEls();
    if (els.count) {
      els.count.textContent = count > 0 ? (count < 100 ? String(count) : '') : '';
      els.count.classList.toggle('hidden', count === 0);
    }
    if (els.bubble) {
      els.bubble.classList.toggle('visually-hidden', count === 0);
    }
    if (els.icon && els.icon.classList) {
      els.icon.classList.toggle('header-actions__cart-icon--has-cart', count > 0);
    }
    // Keep Horizon's own sessionStorage cache in sync so its pageshow
    // "ensureCartBubbleIsCorrect" check can't restore a stale value.
    try {
      sessionStorage.setItem('cart-count', JSON.stringify({ value: String(count), timestamp: Date.now() }));
    } catch (e) {}
  }

  /* ---------- drawer ---------- */
  function getDrawer() { return document.querySelector('cart-drawer-component'); }
  function closeDrawer() {
    if (window.__OT_CHECKOUT_IN_PROGRESS) return;
    var drawer = getDrawer();
    if (!drawer) return;
    // Close unconditionally (closing an already-closed drawer is a no-op).
    // Don't gate on dialog.open — the drawer can be opened via the cart icon
    // in a state our open-detection misses.
    requestAnimationFrame(function () {
      try { if (typeof drawer.close === 'function') drawer.close(); } catch (e) {}
      try {
        var dlg = drawer.querySelector('dialog');
        if (dlg && dlg.open && typeof dlg.close === 'function') dlg.close();
      } catch (e) {}
    });
  }

  /* ---------- authoritative resync ---------- */
  var lastCount = null;
  function resync() {
    if (!origFetch) return;
    origFetch(root() + '/cart.js', {
      headers: { 'Accept': 'application/json' },
      credentials: 'same-origin',
      cache: 'no-store'
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart) return;
        var count = Number(cart.item_count || 0);
        setBubble(count);
        if (count === 0 && lastCount !== 0) closeDrawer();
        lastCount = count;
      })
      .catch(function () {});
  }

  var timer = null;
  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(resync, 90);
  }

  /* ---------- network-level trigger (robust for every flow) ----------
     Events can be missed depending on how the drawer was opened, but every
     cart mutation goes through fetch. Wrap fetch and resync after any
     /cart/add|change|update|clear response — this catches removals made in a
     drawer opened from the cart icon, the cart page, quick-add, anywhere. */
  function asUrl(input) {
    if (typeof input === 'string') return input;
    if (input && typeof input.url === 'string') return input.url;
    return '';
  }
  function isCartMutation(u) {
    return /\/cart\/(add|change|update|clear)(\.js)?($|\?)/.test(u);
  }
  if (origFetch) {
    window.fetch = function (input, init) {
      var p = origFetch(input, init);
      try {
        if (isCartMutation(asUrl(input))) {
          p.then(function () { schedule(); }, function () { schedule(); });
        }
      } catch (e) {}
      return p;
    };
  }

  /* ---------- event triggers (belt-and-suspenders) ---------- */
  document.addEventListener('cart:update', schedule);
  document.addEventListener('cart:added', schedule);
  document.addEventListener('quantity-selector:update', schedule);
  document.addEventListener('dialog:open', schedule);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', resync);
  } else {
    resync();
  }
})();
